import TripPackageSet from '../TripPackageSet';
import type FlightPackage from './FlightPackage';
import { type FlightsMetaDto } from '@clients/FlightApi';
import { type FlightFilters } from '@itinerary/trip/flight/FlightModuleTypes';
import { FlightPackageLoader } from '@itinerary/trip/flight/FlightPackageLoader';
import { type FlightPackageLoaderConfig } from '@itinerary/trip/flight/types';

/**
 * Stores data related to a list of packages, that one of them must be chosen
 */
export default class FlightPackageSet extends TripPackageSet<
    FlightsMetaDto,
    FlightFilters,
    FlightPackage
> {
    override loader: FlightPackageLoader;

    get adultCount() {
        return this.loader.adultCount;
    }

    get childCount() {
        return this.loader.childCount;
    }

    get infantCount() {
        return this.loader.infantCount;
    }

    protected override reset(
        config: FlightPackageLoaderConfig,
        filters: Record<FlightFilters, any>,
        minPrice?: number
    ) {
        super.reset(config, filters, minPrice);
        this.loader = new FlightPackageLoader(config);
    }

    constructor(
        config: FlightPackageLoaderConfig,
        /**
         * Contains filters that must be applied to the results
         */
        public override filters: Record<FlightFilters, any>,

        /**
         * Minimum price that is obtained or expected from the current package set
         */
        public override minPrice?: number,

        public override isSuggestion = false
    ) {
        super(filters, minPrice);
        this.loader = new FlightPackageLoader(config);
    }
}
